import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { injectDispatch } from '@ngrx/signals/events';
import {
  NumberInputComponent,
  SelectInputComponent,
  InputLabelComponent,
} from '@navstation-portal/shared/ui/components';
import { VesselSpecStore } from '@navstation-portal/vessels/data-access/store';
import {
  AbstractStoreConnectedSectionComponent,
  offshoreStockFormEvents,
  OffshoreStockFormStore,
} from '@navstation-portal/reporting/data-access/offshore-report';

@Component({
  selector: 're-tank-transfers',
  templateUrl: './tank-transfers.component.html',
  styleUrl: './tank-transfers.component.css',
  imports: [
    FormsModule,
    SelectInputComponent,
    NumberInputComponent,
    InputLabelComponent,
  ],
})
export class TankTransfersComponent extends AbstractStoreConnectedSectionComponent {
  tabId = 'stock';
  sectionId = 'tankTransfers';
  events = injectDispatch(offshoreStockFormEvents);
  stockStore = inject(OffshoreStockFormStore);
  vesselSpecStore = inject(VesselSpecStore);
}
